import { render, staticRenderFns } from "./flow.vue?vue&type=template&id=4deb3e2c&"
import script from "./flow.vue?vue&type=script&lang=js&"
export * from "./flow.vue?vue&type=script&lang=js&"
import style0 from "./flow.vue?vue&type=style&index=0&id=4deb3e2c&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4deb3e2c')) {
      api.createRecord('4deb3e2c', component.options)
    } else {
      api.reload('4deb3e2c', component.options)
    }
    module.hot.accept("./flow.vue?vue&type=template&id=4deb3e2c&", function () {
      api.rerender('4deb3e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/flow.vue"
export default component.exports